import { render } from "./contactInfo.vue?vue&type=template&id=5934cadf&scoped=true"
import script from "./contactInfo.vue?vue&type=script&lang=js"
export * from "./contactInfo.vue?vue&type=script&lang=js"

import "./contactInfo.vue?vue&type=style&index=0&id=5934cadf&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5934cadf"]])

export default __exports__